import { Stack, formHelperTextClasses } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { ReportFilterKey, ReportFilterValue } from 'src/type/report';
import { isAfter } from 'src/utils/format-time';

type Props = {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  handleFilters: (name: ReportFilterKey, value: ReportFilterValue) => void;
};

export default function ReportPeriodFilters({ startDate, endDate, handleFilters }: Props) {
  const dateError = isAfter(startDate?.toDate(), endDate?.toDate());

  return (
    <Stack spacing={2}>
      <DatePicker
        label="จากวันที่"
        value={startDate}
        onChange={(newValue) => handleFilters('startDate', newValue)}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
          },
        }}
      />

      <DatePicker
        label="ถึงวันที่"
        value={endDate}
        onChange={(newValue) => handleFilters('endDate', newValue)}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            error: dateError,
            helperText: dateError && 'ช่วงวันที่ไม่ถูกต้อง',
          },
        }}
        sx={{
          [`& .${formHelperTextClasses.root}`]: {
            position: { md: 'absolute' },
            bottom: { md: -24 },
          },
        }}
      />
    </Stack>
  );
}
